if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          copyItem: this.querySelector('.share-links__copy-item'),
          copyButton: this.querySelector('.share-links__copy'),
          message: this.querySelector('[id^="ShareMessage"]'),
          manual: this.querySelector('.share-links__manual'),
          urlInput: this.querySelector('.share-links__manual input'),
          nativeItem: this.querySelector('.share-links__native-item'),
          nativeButton: this.querySelector('.share-links__native'),
        };

        // Canonical product URL rendered by Liquid (primary domain, no variant parameter).
        this.urlToShare = this.dataset.url || (this.elements.urlInput && this.elements.urlInput.value) || '';

        if (this.elements.copyButton && this.urlToShare) {
          // The copy option needs JavaScript, so it stays hidden until this point.
          this.elements.copyItem.hidden = false;
          this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        }

        // Optional extra: the device's own share menu (e.g. Instagram Direct/Stories on phones with the app).
        // Only shown where the browser supports it; it never replaces the explicit options above.
        if (this.elements.nativeButton && navigator.share && this.urlToShare) {
          this.elements.nativeItem.hidden = false;
          this.elements.nativeButton.addEventListener('click', this.openNativeShare.bind(this));
        }
      }

      openNativeShare() {
        navigator.share({ title: this.dataset.title || document.title, url: this.urlToShare }).catch(() => {
          // Cancelled by the customer or not allowed: nothing to do, the other options remain visible.
        });
      }

      copyToClipboard() {
        const url = this.urlToShare;

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(url)
            .then(() => this.onCopySuccess())
            .catch(() => this.legacyCopy(url));
        } else {
          this.legacyCopy(url);
        }
      }

      legacyCopy(url) {
        let copied = false;
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, url.length);

        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }

        document.body.removeChild(textarea);
        this.elements.copyButton.focus();

        if (copied) {
          this.onCopySuccess();
        } else {
          this.onCopyError();
        }
      }

      onCopySuccess() {
        this.elements.manual.hidden = true;
        this.showMessage(this.elements.message.dataset.successMessage || window.accessibilityStrings?.shareSuccess || '');
      }

      onCopyError() {
        // Last resort: show the link already selected so the customer can copy it manually.
        this.elements.manual.hidden = false;
        this.elements.urlInput.value = this.urlToShare;
        this.showMessage(this.elements.message.dataset.errorMessage || '');
        this.elements.urlInput.focus();
        this.elements.urlInput.select();
      }

      showMessage(text) {
        const message = this.elements.message;
        clearTimeout(this.messageTimeout);
        // Reset first so screen readers announce the same message again on repeated clicks.
        message.textContent = '';
        setTimeout(() => {
          message.textContent = text;
        }, 50);
        if (this.elements.manual.hidden) {
          this.messageTimeout = setTimeout(() => {
            message.textContent = '';
          }, 4000);
        }
      }

      // Called by product-info.js on variant change. The shared link is intentionally
      // the canonical product URL (without ?variant=), so the existing URL is kept.
      updateUrl() {}
    }
  );
}
